module.exports = __webpack_public_path__ + "img/fx.9f3f4d8c.png";